"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkQualityBars = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const styled_1 = __importDefault(require("../../styles/styled"));
const react_1 = require("react");
const __1 = require("..");
function NetworkQualityBars(props) {
    const [showTooltip, setShowTooltip] = (0, react_1.useState)(false);
    const getNetworkQualityMessage = (0, react_1.useCallback)(() => {
        let message;
        switch (props.quality) {
            case 1:
                message = 'bad';
                break;
            case 2:
                message = 'poor';
                break;
            case 3:
                message = 'fair';
                break;
            case 4:
                message = 'good';
                break;
            case 5:
                message = 'great';
                break;
            default:
                message = 'unknown';
                break;
        }
        return message;
    }, [props.quality]);
    return ((0, jsx_runtime_1.jsx)(__1.Tooltip, Object.assign({ showTooltip: showTooltip, offsetValue: 50, distance: 15, message: (0, jsx_runtime_1.jsxs)(__1.AppText, Object.assign({ color: "dark", size: "small", as: "p" }, { children: [props.remoteUsername.length ? `${props.remoteUsername}'s` : 'The', " network quality is ", getNetworkQualityMessage()] })) }, { children: (0, jsx_runtime_1.jsx)(__1.Row, Object.assign({ width: "100%", height: "100%", padding: '5px 0', alignItems: 'flex-end', onMouseEnter: () => setShowTooltip(true), onMouseOver: () => setShowTooltip(true), onMouseOut: () => setShowTooltip(false) }, { children: (() => {
                const bars = [];
                for (let i = 1; i <= 5; i++) {
                    bars.push((0, jsx_runtime_1.jsx)(Bar, { filled: props.quality >= i, index: i }, `bar-${i}`));
                }
                return bars;
            })() })) })));
}
exports.NetworkQualityBars = NetworkQualityBars;
const Bar = styled_1.default.div(({ filled, index }) => ({
    backgroundColor: filled ? 'white' : 'transparent',
    border: '1px solid white',
    width: '5px',
    marginRight: '2px',
    transition: 'background-color 0.5s',
    height: `${index * 4}px`,
}));
//# sourceMappingURL=network_quality_bars.js.map